import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/**
 * 消防文件管理 API 服务
 */
export const fireFileService = {
  /** 分页查询消防文件列表 */
  queryPage: (params) => axios.get(`${iffApi}/firefile/page`, { params }),

  /** 新增消防文件 */
  save: (data) => axios.post(`${iffApi}/firefile/save`, data),

  /** 编辑消防文件 */
  update: (data) => axios.post(`${iffApi}/firefile/update`, data),

  /** 删除消防文件（逻辑删除） */
  delete: (uuid) => axios.delete(`${iffApi}/firefile/delete/${uuid}`),

  /** 下载消防文件（返回文件字节流） */
  getFile: (uuid) => axios.get(`${iffApi}/firefile/getFile/${uuid}`, { responseType: 'blob' })
};
